module.exports = __webpack_public_path__ + "img/500-Internal-Error-Page.80396a87.gif";